export default "__VITE_ASSET__BbD1vExV__"